import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwelve from "../components/DashBoardLayerTwelve";

const HomePageTwelve = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Assistant Doctors Appointments' />

        {/* DashBoardLayerEleven */}
        <DashBoardLayerTwelve />
      </MasterLayout>
    </>
  );
};

export default HomePageTwelve;
